import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { getTabId } from '../../utils/common'
import { CREATE_PATIENT_VISIT_REMARKS_SUCCESS } from '../patient-side-panel/PatientSidePanelConstants'
import { SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS } from '../file-pop-up/FilePopUpConstants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitsListener = ({ setIsNeedToResetRemarksInputError, setIsNeedToUpdateVisitRemarks, refreshVisits }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action) => {
          const currentTabId = getTabId()

          switch (action.type) {
            case CREATE_PATIENT_VISIT_REMARKS_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setIsNeedToResetRemarksInputError(true)
              } else {
                setIsNeedToResetRemarksInputError(false)
              }
              break

            case SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS:
              if (action.payload) {
                console.log('File tags updated, fetching visits...')
                refreshVisits()
              }
              break

            default:
              break
          }
        },
      }),
    )

    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [dispatch, setIsNeedToResetRemarksInputError, setIsNeedToUpdateVisitRemarks, refreshVisits])

  return null
}
